'use client'

import { useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'
import { useEffect } from 'react'

import { SlideInBody } from '@pearlconvert/ui/components/slide-in'
import { useModals } from '@pearlconvert/ui/providers/modals/modals.context'

const LoyaltyTerminateMembershipConfirmation = dynamic(
  () =>
    import('@maestro/commerce-blocks/loyalty/components/loyalty-terminate-membership-confirmation-modal/loyalty-terminate-membership-confirmation')
)

export default function LoyaltyTerminateMembershipConfirmationModal() {
  const t = useTranslations('commerce-blocks.loyalty')
  const { addModal } = useModals()

  useEffect(() => {
    addModal({
      key: 'terminate-membership',
      hash: 'terminate-membership',
      Component: (
        <SlideInBody>
          <LoyaltyTerminateMembershipConfirmation />
        </SlideInBody>
      ),
      props: {
        title: t('terminate-membership.title'),
        customClassName: 'terminate-membership-modal',
      },
    })
  }, [addModal, t])

  return null
}
